import React from 'react';
import {
  Box,
  Typography,
  Paper,
  IconButton,
  Tabs,
  Tab,
} from '@mui/material';
import ChangePasswordTab from '../../components/Forms/ChangePasswordTab';

const SettingsView = ({ onBack }) => {
  return (
      <Box sx={{ p: 2 }}>
        <Paper
          elevation={0}
          sx={{
            p: 1,
            borderRadius: 2,
            border: 1,
            borderColor: 'divider',
            bgcolor: 'background.paper',
            mb: 2,
          }}
        >
          <Tabs
            value={0}
            aria-label="Settings Tabs"
            TabIndicatorProps={{ sx: { height: 3, borderRadius: 2, bgcolor: 'primary.main' } }}
          >
            <Tab
              label="Change Password"
              sx={{
                textTransform: 'none',
                fontWeight: 600,
                '&.Mui-selected': { color: 'primary.main' },
              }}
            />
          </Tabs>
        </Paper>
        <ChangePasswordTab />
      </Box>
  );
};

export default SettingsView;

